import React, {useState, useEffect} from "react";
import { Form, Row, Select, Col, Input, Button, Collapse ,Card, Table} from 'antd';
import jsonfile from './transaction.json'
import {Link, useHistory, useRouteMatch} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import ActionButton from '../../../../util/actionbutton';
import SmartDataTable from 'react-smart-data-table';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "util/IntlMessages";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import TransactionReceiptModal from "../../../../components/Input/TransactionReceiptModal";

const Search = Input.Search;
const Option = Select.Option;
const Panel = Collapse.Panel;

const AllTransactions = () => {
    const value = 0;
    const [state,setState] = useState({
        reqURL: Config.apiserver+jsonfile.urls.alltransactions,
        filtervalue : '',
        subtitle : '',
    });

    const [beneficiary, setBeneficiary] = useState([]);
    const [beneficiarySelected, setBeneficiarySelected] = useState([]);
    const [selectedBeneficaryList, setSelectedBeneficaryList] = useState({});
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);


    useEffect(() => {
        setState(
            {
                reqURL: Config.apiserver+jsonfile.urls.alltransactions
            }
        );
    }, []);

    useEffect(() => {
        // getPODetails();
        const comID = CisUI().getUserInfo("com_id");
        if(comID > 0) {
            // document.getElementById("loader").style.display = "block";
            axios.get("beneficiary")
                .then((res) => {
                    if(res.data.status === 1) {
                        // console.log(res?.data?.beneficiary);
                        setBeneficiary(res?.data?.beneficiary);
                        setSelectedBeneficaryList(res?.data?.beneficiary_list);
                    }

                    // document.getElementById("loader").style.display = "none";
                })
                .catch((error) => {
                    console.log(error);
                    // document.getElementById("loader").style.display = "none";
                });
        }

    }, []);

    const history = useHistory();

    const headers = {
        // _id: {
        //     text: '#',
        //     invisible: false,
        //     filterable: false,
        //     transform: (value) => `${++value}`,
        // },
        id: {
            invisible : true
        },
        bank_account: {
            invisible : true
        },
        attachments: {invisible: true},
        benificiary_type: {invisible: true},
        benificiary_id: {invisible: true},
        company: {invisible: true},
        date: {
            text: <IntlMessages id="Date"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                <span onClick={()=>onRowClickForDetails(row)} style={{fontWeight: 'bold'}}>{CisUI().DateFormat(value)}</span>
            )
        },
        source: {
            text: <IntlMessages id="Type"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                <span onClick={()=>onRowClickForDetails(row)} style={{fontWeight: 'bold'}}>{value}</span>
            )
        },
        type: {
            text: <IntlMessages id="Payment Method"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                <span onClick={()=>onRowClickForDetails(row)} style={{fontWeight: 'bold'}}>{value}</span>
            )
        },
        head: {
            text: <IntlMessages id="Account"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                <span onClick={()=>onRowClickForDetails(row)} style={{fontWeight: 'bold'}}>{value}</span>
            )
        },
        debit: {
            text: <IntlMessages id="Receipts"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        credit: {
            text: <IntlMessages id="Payment"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        beneficiary: {
            text: <IntlMessages id="Beneficiary"/>,
            sortable: true,
            filterable: true,
        },
        user_name: {
            text: <IntlMessages id="User Name"/>,
            sortable: true,
            filterable: true,
        },
        title: {
            text: <IntlMessages id="Title"/>,
            sortable: true,
            filterable: true,
        },
        reference: {
            text: <IntlMessages id="Reference"/>,
            sortable: true,
            filterable: true,
        },
        actions: {
            text: 'Actions',
            sortable: false,
            filterable: false,
            transform: (value, idx, row) => (
                <>
                    <a href={Config.fileserver+""+row?.attachments} target="_blank" className="btn btn-primary btn-sm btn-circle">
                        <i className="fa fa-file"></i>
                    </a>

                    <a href="#" onClick={()=>onRowClickForDetails(row)} className="btn btn-primary btn-sm btn-circle">
                        <i className="fa fa-eye"></i>
                    </a>

                    {ActionButton(row.id,jsonfile.urls,jsonfile.urls.list)}
                </>
            ),
        },
    };

    const orderedHeaders = jsonfile.listView.title;

    const getFields = () => {
        const count = expand ? 10 : 6;
        const children = [];
        const inputs = jsonfile.input;

        inputs.map((list, index) => {
            if(list.isFilterable == 1) {
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} key={index} style={{display: index < count ? 'block' : 'none'}}>
                        <div className="gx-form-row0">
                            <Form.Item
                                name={`${list.name}`}
                                label={`${list.label}`}
                                rules={[
                                    {
                                        required: true,
                                        message: "",
                                    },
                                ]}
                            >
                                <Input placeholder={list.name} />
                            </Form.Item>
                        </div>
                    </Col>,
                );
            }
        });
        return children;
    };

    const [expand, setExpand] = useState(false);
    const [form] = Form.useForm();

    const onFinish = values => {
        console.log('Received values of form: ', values);
        const qsup = CisUI().getQueryStrings(values);
        //reqURL = reqURL+"/?"+qsup;
        history.push("?"+qsup);
        const newURL = Config.apiserver+jsonfile.urls.alltransactions+"/?"+qsup;
        setState({reqURL: newURL});
    };

    const handleOnFilter = ({ target: { name, value } }) => {
        //filterValue = value;
        // console.log("filteringwith :"+ value);
        setState({filtervalue : "test"});
    }

    const getBeneficairy = (bf_id) => {
        const selectedBF = parseInt(bf_id);
        if(selectedBF > 0) {
            setBeneficiarySelected(selectedBeneficaryList[bf_id]);
        }
    }

    let  searchView = "";
    if(jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']} >
                <Panel header="Advance Search"  key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        <div className="row">
                            <div className="col-md-5">
                                <Form.Item
                                    name="beneficairy_type"
                                    label="Beneficairy Type"
                                    rules={[
                                        {
                                            required: false,
                                            message: "Select a beneficiary"
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select a Beneficairy type"
                                        optionFilterProp="children"
                                        onChange={getBeneficairy}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {
                                            beneficiary?.map((items, index) =>
                                                <Option key={++index} value={items.id}>{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-md-5">
                                <Form.Item
                                    name="beneficairy_id"
                                    label="Beneficairy"
                                    rules={[
                                        {
                                            required: false,
                                            message: "Select a beneficairy"
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select a Beneficairy"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {
                                            beneficiarySelected?.map((items, index) =>
                                                <Option key={++index} value={items.id}>{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        {AdvancedSearch(jsonfile.search,"",1,"",CisUI().PeriodFiled(form))}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const getExtra = (
        <>
            {/*<Search*/}
            {/*    placeholder='Filter...'*/}
            {/*    name='filtervalue'*/}
            {/*    onSearch={handleOnFilter}*/}
            {/*    onChange={handleOnFilter}*/}
            {/*    style={{width: 200}}*/}
            {/*/>*/}
            {CisUI().listActionReport("../"+jsonfile.urls.add,"",state.reqURL,"data",'all_transaction', jsonfile, state.subtitle, "landscape")}
        </>
    );

    const onDetails = (rowData) => {
        setSelected(rowData);
        setOpen(true);
    }

    const onRowClick = (event, { rowData, rowIndex, tableData }) => {
        // The following results should be identical
        console.log(rowData, tableData[rowIndex])
        setSelected(tableData[rowIndex]);
        setOpen(true);
    }

    const onRowClickForDetails = (rowData) => {
        // The following results should be identical
        setSelected(rowData);
        setOpen(true);
    }

    return (
        <>
            {searchView}
            <Card title={jsonfile.listtitle} extra={getExtra}>
                <SmartDataTable
                    name='test-fake-table'
                    data={state.reqURL}
                    dataRequestOptions={CisUI().HeaderRequest}
                    dataKey="data"
                    headers={headers}
                    orderedHeaders={orderedHeaders}
                    hideUnordered={CisUI().hideUnordered}
                    className={CisUI().sematicUI.table}
                    filterValue={state.filterValue}
                    perPage={CisUI().perPage}
                    sortable
                    withLinks
                    // onRowClick={onRowClick}
                    show
                    withHeader
                    loader={CisUI().loader}
                    parseBool={{
                        yesWord: 'Yes',
                        noWord: 'No',
                    }}
                    parseImg={{
                        style: {
                            border: '1px solid #ddd',
                            borderRadius: '50px',
                            padding: '3px',
                            width: '30px',
                            height: '30px'
                        },
                    }}
                    emptyTable={CisUI().emptyTable}
                />

                {/* Render Modal outside the table */}
                {selected && (
                    <TransactionReceiptModal
                        open={open}
                        onClose={() => setOpen(false)}
                        data={selected}
                    />
                )}
            </Card>
        </>
    );
};

export default AllTransactions;